import { initializeApp }  from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBD091JC3cUnRdoO-KjL_WWpxgJZ-aL5Pc",
  authDomain: "phantom-writing.firebaseapp.com",
  projectId: "phantom-writing",
  storageBucket: "phantom-writing.appspot.com",
  messagingSenderId: "931712709397",
  appId: "1:931712709397:web:c816362277017f46f1ef1c",
  measurementId: "G-50DQEN0G3X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };
